// menu-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Ajuste de estoque": "Ajuste de inventario",
    "Anúncios": "Anuncios",
    "Baixa de produto": "Baja de producto",
    "Campanhas": "Campañas",
    "Clientes excluídos": "Clientes eliminados",
    "Entrada de produto": "Entrada de producto",
    "Envio Único": "Envío Único",
    "Estoque": "Inventario",
    "LGPD": "LGPD",
    "Monitoramento": "Monitoreo",
    "Monitoramento de Metas": "Monitoreo de objetivos",
    "Novo: Envio Recorrente!": "Nuevo: ¡Envío Recurrente!",
    "Quadros": "Tableros",
    "Termos de Uso": "Términos de Uso",
    "Transferência": "Transferencia",
};

export default catalogo;
